var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 15.5H11.125C10.6438 15.5 10.25 15.1063 10.25 14.625H4.13375V19.125C4.13375 20.0875 4.92125 20.875 5.88375 20.875H18.125C19.0875 20.875 19.875 20.0875 19.875 19.125V14.625H13.75C13.75 15.1063 13.3562 15.5 12.875 15.5ZM19 6.625H15.5C15.5 4.69125 13.9338 3.125 12 3.125C10.0662 3.125 8.5 4.69125 8.5 6.625H5C4.0375 6.625 3.25 7.4125 3.25 8.375V11.4747C3.25 12.446 4.02875 13.2247 5 13.2247H10.25V12.875C10.25 12.3938 10.6438 12 11.125 12H12.875C13.3562 12 13.75 12.3938 13.75 12.875V13.2247H19C19.9625 13.2247 20.75 12.4372 20.75 11.4747V8.375C20.75 7.4125 19.9625 6.625 19 6.625ZM10.25 6.625C10.25 5.6625 11.0375 4.875 12 4.875C12.9625 4.875 13.75 5.6625 13.75 6.625H10.2413H10.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIcon);
export default __webpack_public_path__ + "static/media/Briefcase Icon.d6b1897959c4fbd46eb7a4859f465d1b.svg";
export { ForwardRef as ReactComponent };